import React from 'react';
import { createRoot } from 'react-dom/client';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { ConnectedRouter } from 'connected-react-router';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import configureStore, { history } from './configureStore';

import Routes from './routes';

import './i18n';
import './assets/tailwind/tailwind.css';
import './index.css';

import * as serviceWorker from './serviceWorker';
import { AppProvider } from './context/AppContext';
import { PageProvider } from './context/PageContext';
import ErrorBoundary from './components/ErrorBoundary/ErrorBoundary';
import { errorToast } from './shared/toast';

const store = configureStore();

toast.configure({
  autoClose: 10000,
  closeButton: false,
  hideProgressBar: true,
  position: toast.POSITION.BOTTOM_RIGHT,
});

const describeError = (reason) =>
  reason?.message || (typeof reason === 'string' ? reason : 'Unknown error');

window.addEventListener('unhandledrejection', (event) => {
  errorToast(`Unexpected error: ${describeError(event.reason)}`);
});

window.addEventListener('error', (event) => {
  errorToast(`Unexpected error: ${describeError(event.error || event.message)}`);
});

const root = createRoot(document.getElementById('root'));
root.render(
  <ErrorBoundary>
    <Provider store={store}>
      <AppProvider>
        <PageProvider>
          <ConnectedRouter history={history}>
            <BrowserRouter>
              <Routes />
            </BrowserRouter>
          </ConnectedRouter>
        </PageProvider>
      </AppProvider>
    </Provider>
  </ErrorBoundary>,
);

serviceWorker.unregister();
